import RailAppMenuController from "./rail_app_menu_controller"

export default class extends RailAppMenuController {
    static targets = ["sectionAction", "sectionActionLabel", "hideForm", "sectionValue", "placementValue", "placementLabel", "placementIcon"]

    _expanded() {
        return !document.body.classList.contains("jane-nav-bottom") && super._expanded()
    }

    _appLink(target) {
        return target?.closest?.("a[data-core-nav]")
    }

    _fill(link) {
        this.sectionActionLabelTarget.textContent = link.dataset.coreActionLabel
        this.sectionActionTarget.href = link.dataset.coreActionUrl
        this.sectionValueTarget.name = `visibility[${link.dataset.coreNav}]`
        const folded = link.dataset.corePlacement === "more"
        this.placementValueTarget.name = `placement[${link.dataset.coreNav}]`
        this.placementValueTarget.value = folded ? "shown" : "more"
        this.placementLabelTarget.textContent = folded ? "Move above More" : "Move under More"
        this.placementIconTarget.className = `bi ${folded ? "bi-arrow-bar-up" : "bi-arrow-bar-down"}`
        if (link.dataset.coreNav === "messages") {
            this.sectionActionTarget.dataset.action = "messages-sidebar#composeTo core-nav-menu#choose"
            this.sectionActionTarget.dataset.composeUrl = link.dataset.coreActionUrl
            this.sectionActionTarget.dataset.composeTitle = "New message"
        } else {
            delete this.sectionActionTarget.dataset.action
        }
    }

    choose() { this.closeMenu(); this._hideMore() }

    edit() {
        this.choose()
        window.dispatchEvent(new Event("navigation:edit"))
    }
}
